/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 
 */


class BarrowsGreenMap extends HTMLElement {
  constructor() {
    super();

    this.layers = Array.from(this.querySelectorAll("[data-layer]"));
    this.cards = Array.from(this.querySelectorAll("[data-card]"));
    this.areas = Array.from(this.querySelectorAll("area"));

    this.frameInner = this.querySelector("[data-frame-inner]");
    this.map = this.querySelector("[data-map]");

    if (this.cards[0] && window.innerWidth < 750) {
      this.cards[0].classList.add("js-visible");
    }

    this.cards.forEach((card, index) => {
      const prevCard = index >= 1 ? this.cards[index - 1] : null;
      const nextCard =
        index < this.cards.length - 1 ? this.cards[index + 1] : null;

      const prevButton = card.querySelector("[data-button-prev]");
      const nextButton = card.querySelector("[data-button-next]");

      prevButton.addEventListener("click", () => {
        this.hideCard(card);
        this.showCard(prevCard);
        this.showLayer(prevCard.dataset.layerId);
      });

      nextButton.addEventListener("click", () => {
        this.hideCard(card);
        this.showCard(nextCard);
        this.showLayer(nextCard.dataset.layerId);
      });
    });

    this.areas.forEach((area) => {
      area.addEventListener("mouseenter", this.onAreaMouseEnter.bind(this));
      area.addEventListener("mouseleave", this.onAreaMouseLeave.bind(this));
      area.addEventListener("click", this.onAreaClick.bind(this));
    });

    this.hovers = {};
  }

  hideCard(card) {
    card.classList.remove("js-visible");
  }

  showCard(card) {
    card.classList.add("js-visible");

    if (this.cards.indexOf(card) == 0) {
      this.classList.remove("js-zoom");
    } else {
      this.classList.add("js-zoom");
    }
  }

  onAreaClick(event) {
    event.preventDefault();
  }

  getLayer(id) {
    return this.layers.find((layer) => layer.dataset.layerId == id);
  }

  showLayer(id) {
    let layerShown;
    this.layers.forEach((layer) => {
      if (layer.dataset.layerId == id) {
        layer.classList.add("js-visible");
        layerShown = layer;
      } else {
        layer.classList.remove("js-visible");
      }
    });

    if (layerShown) {
      const coordX = layerShown.dataset.coordX;
      const coordY = layerShown.dataset.coordY;

      const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

      const translateX = ((coordX - 50) / 100) * 0.75;
      const translateY = ((coordY - 50) / 100) * 0.65;
      const translateXPercentage = (translateX * 100 * -1).toFixed(2) + "%";
      const translateYPercentage = (translateY * 100 * -1).toFixed(2) + "%";

      console.log("Translate", translateXPercentage);
      this.dimMap();
      this.map.style.transform = `scale(2.5) translate(${translateXPercentage}, ${translateYPercentage})`;
    } else {
      this.map.style.transform = null;
      this.undimMap();
    }
  }

  onAreaMouseEnter(event) {
    const area = event.target;
    const { layerId } = area.dataset;
    this.hovers[layerId] = true;

    const layer = this.getLayer(layerId);
    this.classList.add("js-hovered-once");

    const card = this.cards.find((card) => card.dataset.layerId == layerId);
    card.classList.add("js-visible");
    layer.classList.add("js-hover");

    this.dimMap();
  }

  onAreaMouseLeave(event) {
    const area = event.target;
    const { layerId } = area.dataset;
    delete this.hovers[layerId];

    const layer = this.getLayer(layerId);
    layer.classList.remove("js-hover");

    const card = this.cards.find((card) => card.dataset.layerId == layerId);
    card.classList.remove("js-visible");

    this.undimMap();
  }

  dimMap() {
    this.lastDimRequestTime = null;
    this.classList.add("js-hover");
  }

  undimMap() {
    const dimRequestTime = Date.now();
    this.lastDimRequestTime = dimRequestTime;

    setTimeout(() => {
      if ((this.lastDimRequestTime = dimRequestTime)) {
        if (Object.keys(this.hovers).length == 0) {
          this.classList.remove("js-hover");
        }
      }
    }, 250);
  }
}

customElements.define("barrows-green-map", BarrowsGreenMap);

class ShopScene extends HTMLElement {
  constructor() {
    super();

    this.scenes = Array.from(this.querySelectorAll("[data-scene]"));
    this.sceneSelectors = Array.from(
      this.querySelectorAll("[data-scene-selector]")
    );

    this.activeSection = this.scenes.find((scene) =>
      scene.classList.contains("js-active")
    );

    this.sceneSelectors.forEach((selector) =>
      selector.addEventListener("click", () => {
        this.showScene(
          this.scenes.find((scene) => scene.id == selector.dataset.sceneId)
        );
      })
    );

    this.scenes.forEach((scene) => {
      const showButton = scene.querySelector("[data-scene-show-button]");

      showButton.addEventListener("click", (e) => this.toggleProducts(scene));
    });
  }

  showScene(scene) {
    if (this.activeSection) {
      this.hideProducts(this.activeSection);
    }

    this.sceneSelectors.forEach((selector) =>
      selector.classList.remove("js-active")
    );

    const sceneSelector = this.sceneSelectors.find(
      (selector) => selector.dataset.sceneId == scene.id
    );

    if (sceneSelector) {
      sceneSelector.classList.add("js-active");
    }

    this.scenes.forEach((scene) => {
      scene.classList.remove("js-active");
    });

    scene.classList.add("js-active");

    this.activeSection = scene;
  }

  hideProducts(scene) {
    scene.querySelector("[data-scene-products]").classList.remove("js-active");
  }

  toggleProducts(scene) {
    scene.querySelector("[data-scene-products]").classList.toggle("js-active");
  }
}

customElements.define("shop-scene", ShopScene);

